module.exports = __webpack_public_path__ + "img/chord-label-F.a7dacd61.png";